<template>
  <componentHeader v-if="isShowHeader"></componentHeader>
  <el-config-provider :locale="locale">
    <div class="app-content">
      <router-view></router-view>
    </div>
  </el-config-provider>
  <componentFooter v-if="!isShowFooter"></componentFooter>
  <el-backtop :bottom="100">
    <div class="to-top">
      <img src="@/assets/image/fanhui-2.png" alt="" />
    </div>
  </el-backtop>
</template>
<script setup>
import { ref, watch, onMounted, reactive, watchEffect } from "vue";
import componentHeader from "@/components/header/index.vue";
import componentFooter from "@/components/footer/index.vue";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { useRouter } from "vue-router";

const locale = ref(zhCn);
const router = useRouter();
const isShowHeader = ref(false);
const isShowFooter = ref(false);

watch(
  () => router.currentRoute.value.name,
  (newValue) => {
    isShowHeader.value = newValue === "enterpriseList" ? false : true;
  }
);
watch(
  () => router.currentRoute.value.query.iframe,
  (flag) => {
    isShowFooter.value = flag === "false" ? false : true;
  }
);
onMounted(() => {
  // 供应商与登录账号是否一致  一致1  不一致0
  // localStorage.setItem(
  //   "isSupplierLoginNo",
  //   params.isSupplierLoginNo && params.isSupplierLoginNo == 1 ? 1 : 0
  // );

});
</script>
<style lang="scss">
.app-content {
  min-height: calc(100vh - 610px);
}

.el-backtop {
  width: 62px;
  height: 62px;
  background: #ededed;

  &:hover {
    img {
      transform: scale(1.5);
    }
  }

  .to-top {
    border-radius: 31px;
    transition: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 25px;
      transition: all 0.35s;
      height: 25px;
    }
  }
}
</style>